/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CustomerProductResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCustomerProductsByCustomerIdResponse, GetCustomerProductHistoryTimelineResponse, GetCustomerProductHistoryByCustomerIdResponse, GetCustomerProductBillingsByCustomerIdResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CustomerProductResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCustomerProductsByCustomerId(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCustomerProductsByCustomerIdResponse, unknown> & { defaultValue: NoInfer<GetCustomerProductsByCustomerIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductsByCustomerIdResponse>;
    getCustomerProductsByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductsByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductsByCustomerIdResponse | undefined>;
    getCustomerProductsByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductsByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductsByCustomerIdResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const customerIdValue = typeof customerId === 'function' ? customerId() : customerId;
            if (customerIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdValue, 'customerId');
            }
            return {
                url: `${this.basePath}/CustomerProduct`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCustomerProductHistoryTimeline(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetCustomerProductHistoryTimelineResponse, unknown> & { defaultValue: NoInfer<GetCustomerProductHistoryTimelineResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryTimelineResponse>;
    getCustomerProductHistoryTimeline(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetCustomerProductHistoryTimelineResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryTimelineResponse | undefined>;
    getCustomerProductHistoryTimeline(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetCustomerProductHistoryTimelineResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryTimelineResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/CustomerProduct/history/timeline`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCustomerProductHistoryByCustomerId(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCustomerProductHistoryByCustomerIdResponse, unknown> & { defaultValue: NoInfer<GetCustomerProductHistoryByCustomerIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryByCustomerIdResponse>;
    getCustomerProductHistoryByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductHistoryByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryByCustomerIdResponse | undefined>;
    getCustomerProductHistoryByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductHistoryByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductHistoryByCustomerIdResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const customerIdValue = typeof customerId === 'function' ? customerId() : customerId;
            if (customerIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdValue, 'customerId');
            }
            return {
                url: `${this.basePath}/CustomerProduct/history`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCustomerProductBillingsByCustomerId(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCustomerProductBillingsByCustomerIdResponse, unknown> & { defaultValue: NoInfer<GetCustomerProductBillingsByCustomerIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductBillingsByCustomerIdResponse>;
    getCustomerProductBillingsByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductBillingsByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductBillingsByCustomerIdResponse | undefined>;
    getCustomerProductBillingsByCustomerId(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerProductBillingsByCustomerIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerProductBillingsByCustomerIdResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const customerIdValue = typeof customerId === 'function' ? customerId() : customerId;
            if (customerIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdValue, 'customerId');
            }
            return {
                url: `${this.basePath}/CustomerProduct/billings`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
